import { useNavigate } from 'react-router';
import { Branding } from 'src/api/branding/types';
import { useGetMyBrandsQuery } from 'src/api/branding/hooks';
import { DataTable } from 'src/components/DataTable';
import { ActionMenu } from 'src/components/DataTable/ActionMenu';
import { Td } from 'src/components/DataTable/Td';
import { links } from 'src/router/routes';
import { useCallback, useMemo } from 'react';
import { useGlobalModals } from 'src/contexts/global-modals';

const columns = [
  {
    key: 'id',
    label: 'ID',
  },
  {
    key: 'name',
    label: 'Name',
  },
  {
    key: 'created_at',
    label: 'Created at',
  },
  {
    key: 'updated_at',
    label: 'Last updated at',
  },
];

export const BrandsDataTable = () => {
  const { data: brands, isLoading } = useGetMyBrandsQuery();
  const { openDeleteBrandingModal } = useGlobalModals();
  const navigate = useNavigate();

  const handleRowClick = useCallback(
    (brandId: number) => {
      navigate(`${links.branding}/${brandId}`);
    },
    [navigate]
  );

  const getContent = useCallback(
    (brand: Branding) => {
      return (
        <>
          <Td>{brand.id}</Td>
          <Td>{brand.name}</Td>
          <Td>{new Date(brand.created_at).toLocaleDateString()}</Td>
          <Td fullWidth>
            <span>{new Date(brand.updated_at).toLocaleDateString()}</span>
            <ActionMenu
              onEdit={() => navigate(`${links.branding}/${brand.id}`)}
              onRemove={() => openDeleteBrandingModal(brand.id)}
            />
          </Td>
        </>
      );
    },
    [navigate]
  );

  const getRows = useCallback((brand: Branding) => {
    return {
      created_at: brand.created_at,
      id: String(brand.id),
      name: brand.name,
      updated_at: brand.updated_at,
    };
  }, []);

  const data = useMemo(() => {
    return (
      brands?.map((brand) => ({
        content: getContent(brand),
        onRowClick: () => handleRowClick(brand.id),
        rows: getRows(brand),
      })) || []
    );
  }, [brands, getContent, getRows, handleRowClick]);

  return <DataTable columns={columns} data={data} isLoading={isLoading} />;
};
